import * as React from 'react';
import { translation, DateFormat, TimeFormat } from 'easit--localization';
import { IconTooltip } from 'common--design-library';
import { TableRow, TablePanel } from 'desktop--design-library';
import { numberFormatter, currencyFormatter, dateFormatter, translationForTipos } from '../../../../../localization/localization';

export interface IBetDetailHeaderProps {
    identifierSecure: string,
    stateResult: string,
    channelName: string,
    couponTypeName: string,
    couponPaid: Date,
    couponCanBeCancelled: boolean,
    dateCancelationLimit: Date,
    stake: number,
    rate?: number,
    rateAdvantageFactor?: number,
    rateAdvanced?: number,
    prizePaidAmount?: number,
    winPaid?: number,
    prizePotential: number,
    betTypeName: string,
    cinchCount?: number,
    alarmTitle?: string,
    alarmTooltip?: string
}


export const BetDetailHeader: React.FC<IBetDetailHeaderProps> = (props) => {

    return <div className="d-flex">
        <TablePanel className={"betdetail-header-info d-flex flex-column"} strapped>
            {renderBetDetailHeaderRow(translation().ticket_code, props.identifierSecure)}
            {renderBetDetailHeaderRow(translation().state, props.stateResult)}
            {!!props.alarmTitle && renderBetDetailHeaderRow(translation().bet_TicketReasonTitle, props.alarmTitle, props.alarmTooltip)}
            {renderBetDetailHeaderRow(translation().date_paid, dateFormatter.formatDateTime(props.couponPaid, DateFormat.DDMMYY, TimeFormat.HHMMSS))}
            {renderBetDetailHeaderRow(translation().stake, currencyFormatter.format(props.stake))}
            {!!props.rate && renderBetDetailHeaderRow(translation().final_rate, numberFormatter.format(props.rate))}
            {!!props.rateAdvantageFactor && renderBetDetailHeaderRow(translationForTipos().rate_advantage, numberFormatter.format(props.rateAdvantageFactor))}
            {!!props.rateAdvanced && renderBetDetailHeaderRow(translationForTipos().rate_advanced, numberFormatter.format(props.rateAdvanced))}
            {renderBetDetailHeaderRow(translation().eventual_win, currencyFormatter.format(props.prizePotential))}
            {!!props.prizePaidAmount && renderBetDetailHeaderRow(translation().prize_paid, currencyFormatter.format(props.prizePaidAmount))}
            {!!props.winPaid && renderBetDetailHeaderRow(translation().win_paid, currencyFormatter.format(props.winPaid))}
            {renderBetDetailHeaderRow(translation().ticket_type, props.couponTypeName)}
            {renderBetDetailHeaderRow(translation().bet_type, props.betTypeName)}
            {!!props.cinchCount && renderBetDetailHeaderRow(translationForTipos().cinch_count, `${props.cinchCount}`)}
            {
                !!props.dateCancelationLimit &&
                renderBetDetailHeaderRow(translationForTipos().bet_CancelUntil, dateFormatter.formatDateTime(props.dateCancelationLimit, DateFormat.DDMMYY, TimeFormat.HHMMSS), '', 'font-weight-bold')
            }
            {renderBetDetailHeaderRow(translation().channel, props.channelName)}
        </TablePanel>
    </div>
}

export const renderBetDetailHeaderRow = (label: string, value: React.ReactNode, tooltip?: string, customClass?: string) => {
    return <TableRow className={`${customClass}`} verticalAlign={"center"} horizontalAlign={"left"}>
        <div className={"w-50 px-2 py-1"}>{label}</div>
        <div className={"w-50 px-2 py-1"}>{value}
            {tooltip && <IconTooltip
                targetid={`betdetail-alarm-tooltip`}
                target={<span id={`betdetail-alarm-tooltip`} className="etip-info ml-125" />}>
                <div>{tooltip}</div>
            </IconTooltip>}
        </div>
    </TableRow>
}